
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'order',
      component: () => import('@/components/Order.vue')
    },
    {
      path: '/return',
      name: 'return',
      component: () => import('@/components/Return.vue')
    }
  ]
})

export default router
